import React from 'react';
import View from './View';
import { Theme } from '../../../theme';

interface CardProps {
  style?: any;
  children?: React.ReactNode;
  [key: string]: any;
}

const Card = ({ style, children, ...rest }: CardProps) => (
  <View
    style={[
      {
        padding: '8pt',
        borderRadius: '8pt',
        border: `1pt solid ${Theme.colors.greyLight}`,
      },
      style,
    ]}
    {...rest}
  >
    {children}
  </View>
);

export default Card;
